{
  "panel": {
    "title": "报告",
    "previewTitle": "报告预览",
    "loading": "正在加载报告……",
    "empty": "尚未生成任何章节。",
    "emptyTitle": "尚未生成内容",
    "emptyHint": "生成开始后，章节与引用将显示在此处。",
    "loadFailed": "无法加载报告。",
    "ariaPreviousVersion": "上一版本",
    "ariaNextVersion": "下一版本",
    "ariaEditSection": "编辑章节",
    "ariaSaveChanges": "保存更改",
    "ariaCancelEditing": "取消编辑",
    "tooltipEdit": "编辑",
    "section": {
      "pendingHint": "内容生成后将在此处显示。",
      "contextUnavailable": "本节的上下文检索失败。请尝试重新生成，或上传更多源文件。",
      "loading": "正在加载本节内容…",
      "unavailable": "本节显示已完成，但没有已保存的内容。",
      "needsAction": "本节没有已保存的内容，需要重新生成。",
      "acceptedNoContent": "已接受 — 无内容",
      "awaitingExecSummary": "所有章节完成后才会编写执行摘要。",
      "loadFailed": "无法加载本节内容。",
      "reload": "重新加载内容"
    }
  },
  "generation": {
    "starting": "正在启动报告生成……",
    "generating": "正在生成章节……",
    "sectionsCompleted": "已完成 {{completed}} / {{total}} 个章节",
    "currentSection": "正在生成：{{title}}",
    "complete": "报告起草完成。",
    "failed": "报告生成失败。",
    "abort": "中止生成",
    "aborting": "正在中止……",
    "aborted": "生成已中止。",
    "regenerate": "重新生成报告",
    "regenerating": "正在重新生成……",
    "retryFailed": "重试失败的章节",
    "progressSections": "正在生成章节：已完成 {{completed}} / {{total}}",
    "progressSectionsRegenerating": "正在生成章节：已完成 {{completed}} / {{total}}（{{regenerating}} 个正在重新生成）",
    "progressCohortWait_one": "整体检查待进行 — {{count}} 个章节正在等待本批完成",
    "progressCohortWait_other": "整体检查待进行 — {{count}} 个章节正在等待本批完成",
    "progressExtractingSymptoms": "正在等待问题汇总…",
    "progressAggregatingIssues": "正在准备问题日志…",
    "progressValidatingReport": "正在验证报告…",
    "initiatingGeneration": "正在启动生成…",
    "generatingSections": "正在生成报告章节…",
    "progressExecSummary": "正在生成执行摘要…",
    "progressAwaitingValidation": "章节正在等待验证…"
  },
  "section": {
    "untitled": "未命名章节",
    "draft": "草稿",
    "validated": "已自检",
    "generating": "正在生成……",
    "failed": "生成失败",
    "regenerate": "重新生成章节",
    "regenerating": "正在重新生成……",
    "regenerateConfirm": "确定要重新生成此章节吗？",
    "regenerateConfirmBody": "当前草稿将被替换，引用将根据当前文件重新生成。",
    "feedback": "提交反馈",
    "feedbackTitle": "章节反馈",
    "feedbackPlaceholder": "此章节需要做出哪些修改？",
    "feedbackSubmit": "发送反馈",
    "feedbackSubmitting": "正在发送反馈……",
    "feedbackSent": "反馈已收到，正在重新生成……",
    "feedbackEmpty": "请先描述您的反馈。",
    "edit": "编辑",
    "save": "保存",
    "cancel": "取消",
    "saving": "正在保存……",
    "saveFailed": "无法保存编辑。",
    "expand": "展开",
    "collapse": "收起",
    "viewSources": "查看来源",
    "noContent": "暂无内容。",
    "errorBody": "此章节生成失败。点击重试以再次尝试。"
  },
  "citation": {
    "viewSource": "查看来源",
    "openFile": "打开文件",
    "page": "第 {{n}} 页",
    "pages": "第 {{from}}–{{to}} 页",
    "evidence": "证据",
    "loading": "正在加载引用……",
    "loadFailed": "无法加载引用。"
  },
  "execSummary": {
    "title": "执行摘要",
    "generating": "正在生成摘要……",
    "complete": "摘要已就绪。",
    "failed": "摘要生成失败。",
    "regenerate": "重新生成摘要"
  },
  "holisticValidation": {
    "title": "整体自检",
    "running": "正在执行跨章节检查……",
    "passed": "所有跨章节检查均已通过。",
    "issuesFound": "发现 {{count}} 个问题",
    "issuesFound_other": "发现 {{count}} 个问题",
    "viewIssues": "查看问题",
    "fixAll": "全部修复",
    "fixing": "正在修复……"
  },
  "export": {
    "button": "导出",
    "buttonDocx": "导出 DOCX",
    "buttonPdf": "导出 PDF",
    "exporting": "正在导出……",
    "ready": "导出已就绪。",
    "failed": "导出失败。",
    "downloadHere": "下载",
    "exportTitle": "导出报告",
    "format": "格式",
    "includeAppendix": "包含附录",
    "includeCitations": "包含引用列表"
  },
  "artifacts": {
    "title": "工件",
    "showSpec": "显示规范",
    "hideSpec": "隐藏规范"
  },
  "execSummaryPinned": {
    "label": "已固定",
    "tooltip": "您编辑过此摘要，因此系统会保留您的版本，不会自动刷新。如需重写，请使用“反馈”。"
  }
}
